export enum QuantityFields {
  approvedDonationsMl = 'approvedDonationsMl',
  unit = 'unit',
  actual = 'actual',
  failedReason = 'failedReason',
}
